import React from "react";
import { Locale } from "@linkfluence/models/locale";
import InlineRecap from "@radarly/components/clause/labels/inline-recap";
import { tr } from "@radarly/i18n";
import { ClauseLabels } from "@radarly/models/clause/label";

export default function SubheaderFilters({
  labels,
  locale,
}: {
  labels: ClauseLabels[];
  locale: Locale;
}) {
  return (
    <>
      {tr(locale, "INSIGHT_PAGES::PAGE::SNAPSHOT-SELECTED-FILTERS")}{" "}
      <InlineRecap clausesLabels={labels} locale={locale} />
    </>
  );
}
